import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SidebarCardExpandComponent } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/components/sidebar-card/sidebar-card-expand/sidebar-card-expand.component';
import { SideBarCardExpandAnimation } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/components/sidebar-card/sidebar-card.component';

@Component({
  selector: 'app-cp-compare-sidebar-consumption',
  templateUrl: './cp-compare-sidebar-consumption.component.html',
  styleUrls: ['./cp-compare-sidebar-consumption.component.scss'],
  animations: [SideBarCardExpandAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareSidebarConsumptionComponent {

  // This is used to open the sidebar card when the user clicks on all the card (not only the expand button)
  toggle(sidebarCardExpand: SidebarCardExpandComponent) {
    sidebarCardExpand.toggle();
  }

}

